import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fcedefa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isBusinessForFinanceBackend)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "pro"))
    : _createCommentVNode("", true)
}